export default __webpack_public_path__ + "static/media/Thug's Tunic of the Hidden Tomb.0ecbb76c.jpg";